import Actions from "./constants";
import { IActionObject } from "./types";

export function setYouVisitAnalyticsConfig(data: object): IActionObject {
  return { type: Actions.SET_ANALYTICS_CONFIG, data };
}

export function setIsRegistered(): IActionObject {
  return { type: Actions.SET_IS_REGISTERED };
}

export function setPersonalizationEnabled(data: boolean): IActionObject {
  return { type: Actions.SET_PERSONALIZATION_ENABLED, data };
}

export function setExperienceOffline(data: boolean): IActionObject {
  return { type: Actions.SET_EXPERIENCE_OFFLINE, data };
}

export function setExperienceNotFound(data: boolean): IActionObject {
  return { type: Actions.SET_EXPERIENCE_NOT_FOUND, data };
}

export default {
  setYouVisitAnalyticsConfig,
};
